var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24.444 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  "data-name": "Group 32467"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.176.407a1.36 1.36 0 0 0-1.95.008L4.793 6.974A1.11 1.11 0 1 0 6.36 8.546l4.365-4.383c.215-.216.389-.14.389.166v12.093a1.11 1.11 0 0 0 1.108 1.115 1.11 1.11 0 0 0 1.108-1.115V4.329c0-.307.175-.381.389-.166l4.365 4.383a1.11 1.11 0 1 0 1.564-1.572Z",
  "data-name": "Path 18748"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.222 22.221a.56.56 0 0 1-.556.554H2.778a.557.557 0 0 1-.556-.554v-3.893a1.111 1.111 0 1 0-2.222 0v5.006a1.67 1.67 0 0 0 1.672 1.665h21.1a1.67 1.67 0 0 0 1.672-1.665v-5.006a1.111 1.111 0 1 0-2.222 0Z",
  "data-name": "Path 18749"
}))));
export default SvgUpload;